import ApartmentIcon from '@material-ui/icons/Apartment';
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import EmailIcon from "@material-ui/icons/Email";
import PhoneIcon from "@material-ui/icons/Phone";
import { Box, Button, InputAdornment, TextField } from "@mui/material";
import { providerEmailExists, providerMobileExists } from 'hooks/providerHooks/useGetAllProvider';
import { useState } from "react";
import { LeadGenerationService } from 'services/LeadGenerationService/LeadGenerationService';
const GRADIENT = "linear-gradient(135deg, rgb(255, 113, 61) 0%, rgb(245, 159, 10) 100%)";

const StepOneUserForm = ({ planTitle, onNext, initialValues = {} }) => {

    const [data, setData] = useState({
        name: initialValues.name || "",
        email: initialValues.email || "",
        mobile: initialValues.mobile || "",
    });
    // const [data, setData] = useState({
    //     name: "",
    //     email: "",
    //     mobile: "",
    // });

    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);


    const validate = async () => {
        const newErrors = {};

        if (!data.name.trim()) {
            newErrors.name = "Name is required";
        }

        if (!data.email.trim()) {
            newErrors.email = "Email is required";
        } else if (
            !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)
        ) {
            newErrors.email = "Enter a valid email address";
        } else {
            const emailExists = await providerEmailExists(data.email, 0);
            if (emailExists === true) {
                newErrors.email = "Email already exists";
            }
        }

        if (!data.mobile.trim()) {
            newErrors.mobile = "Mobile number is required";
        } else if (!/^[6-9]\d{9}$/.test(data.mobile)) {
            newErrors.mobile = "Enter a valid 10-digit mobile number";
        } else {
            const mobileExists = await providerMobileExists(data.mobile, 0);
            if (mobileExists === true) {
                newErrors.mobile = "Mobile number already exists";
            }
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    let defalutDta = {
        Platform: "Learningfitbit",
        // Percentile: null,
        // Branch: null,
        // City: null

    };
    const handleNext = async () => {
        const isValid = await validate();
        if (!isValid) return;
        try {
            setLoading(true);
            const payload = {
                fullName: data.name,
                email: data.email,
                mobile: data.mobile,
                packageName: planTitle,
            };

            let pylod = Object.assign(defalutDta, payload);
            const response = await LeadGenerationService(pylod);
            console.log(response, '-responses')
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
        onNext(data);
    };




    return (
        <>
            <TextField
                fullWidth
                label="Institute Name"
                margin="normal"
                value={data.name}
                error={!!errors.name}
                helperText={errors.name}
                onChange={(e) =>
                    setData({ ...data, name: e.target.value })
                }
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <ApartmentIcon />
                        </InputAdornment>
                    ),
                }}
            />

            <TextField
                fullWidth
                label="Mobile"
                margin="normal"
                value={data.mobile}
                error={!!errors.mobile}
                helperText={errors.mobile}
                inputProps={{ maxLength: 10 }}
                onChange={(e) =>
                    setData({ ...data, mobile: e.target.value.replace(/\D/g, "") })
                }
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <PhoneIcon />
                        </InputAdornment>
                    ),
                }}
            />

            <TextField
                fullWidth
                label="Email"
                margin="normal"
                value={data.email}
                error={!!errors.email}
                helperText={errors.email}
                onChange={(e) =>
                    setData({ ...data, email: e.target.value })
                }
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <EmailIcon />
                        </InputAdornment>
                    ),
                }}
            />

            <Box mt={2} textAlign="right">
                <Button
                    fullWidth
                    variant="contained"
                    onClick={handleNext}
                    disabled={loading}
                    endIcon={!loading && <span className="arrow" style={{ display: "flex" }}><ArrowForwardIcon /></span>}
                    sx={{
                        // my: 2,
                        py: 1.5,
                        fontSize: '1rem',
                        fontWeight: "600",
                        textTransform: 'none',
                        borderRadius: '0.75rem',
                        background: GRADIENT,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 1,
                        transition: "all 0.3s ease",
                        "& .arrow": {
                            transition: "transform 0.3s ease",
                        },
                        "&:hover .arrow": {
                            transform: "translateX(6px)",
                        },
                    }}
                >
                    {loading ? "Loading..." : "Next"}
                </Button>
            </Box >
        </>
    );
};

export default StepOneUserForm;

